import Reveal from "../components/Reveal";

export default function PageHeader({ eyebrow, title, subtitle, italicWord }) {
  const renderTitle = () => {
    if (!italicWord) return title;
    const [before, after] = title.split(italicWord);
    return (
      <>
        {before}
        <em className="italic text-brand-gold font-light">{italicWord}</em>
        {after}
      </>
    );
  };
  return (
    <section className="pt-40 pb-16 md:pb-24 bg-brand-ink text-brand-ivory relative overflow-hidden grain" data-testid="page-header">
      <div className="absolute inset-0 opacity-30 pointer-events-none" style={{ backgroundImage: "radial-gradient(circle at 20% 80%, rgba(212,160,23,0.3), transparent 60%)" }} />
      <div className="container-luxe relative">
        <Reveal>
          <div className="flex items-center gap-3">
            <span className="w-10 h-px bg-brand-gold" />
            <span className="overline">{eyebrow}</span>
          </div>
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl mt-6 leading-[1.02] tracking-tight max-w-3xl">
            {renderTitle()}
          </h1>
          {subtitle && <p className="mt-8 text-brand-ivory/65 text-lg leading-relaxed max-w-2xl">{subtitle}</p>}
        </Reveal>
      </div>
    </section>
  );
}
